import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import QuoteForm from './QuoteForm';

class QuoteModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    quote: PropTypes.object,
    shipper: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  };

  handleHide = () => {
    this.props.onHide();
  };

  render() {
    const { show, quote, t } = this.props;
    const title =
      quote && quote.quote_id
        ? t('EDIT_QUOTE_WITH_VALUE', { editQuote: quote.quote_id })
        : t('GET_A_QUOTE');

    return (
      <Modal show={show} backdrop="static" onHide={this.handleHide}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <QuoteForm
            onCancel={this.handleHide}
            shipper={this.props.shipper}
            quote={this.props.quote}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(QuoteModal);
